import { render } from "./CaptchaStep.vue?vue&type=template&id=604ac9b6&scoped=true"
import script from "./CaptchaStep.vue?vue&type=script&lang=js"
export * from "./CaptchaStep.vue?vue&type=script&lang=js"

import "../assets/css/bootstrap.min.css?vue&type=style&index=0&id=604ac9b6&scoped=true&lang=css"

import exportComponent from "D:\\archive\\my8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604ac9b6"]])

export default __exports__